export const GTM_URL = 'https://www.googletagmanager.com/gtag/js?id=';
export const GTM_HTML = 'https://www.googletagmanager.com/ns.html?id=';
export const TOKEN_ID = 'YBe8CMmgiZcCENSeg_ID';
export const EXPIRY_DAYS = 90;
export const GCLID = 'gclid';
export const EVENT_LOAD = 'pageload';
export const DEVICE_TYPE = 'web';
